import { type RefObject, useEffect } from 'react';
import { BestPrice, SaveUpTo } from '@hungryroot/icons';
import { Heading } from '@hungryroot/ramen';
import { ValuePropComponentTheme } from '../../defs/valueProp';
import { setSavedNavState } from '../../navigation/navigation';
import { ValuePropCard } from '../ValuePropCard/ValuePropCard';
import { ValuePropLayout } from '../ValuePropLayout/ValuePropLayout';
import styles from './BudgetBenefits.module.css';

interface Props {
  testid: string;
  next: string | null;
  prev: string | null;
  scrollRef: RefObject<HTMLDivElement>;
}

function getCards() {
  return [
    <ValuePropCard
      theme={ValuePropComponentTheme.PeanutButter}
      icon={<BestPrice />}
      text={
        <Heading variant="H4" className={styles['card-heading']}>
          <span className={styles['text-break']}>Our Best Price Program </span>
          <span className={styles['text-transparent']}>
            offers brands you love at the cheapest price you’ll find them.
          </span>
        </Heading>
      }
    />,
    <ValuePropCard
      theme={ValuePropComponentTheme.PeanutButter}
      icon={<SaveUpTo />}
      text={
        <Heading variant="H4" className={styles['card-heading']}>
          <span className={styles['text-transparent']}>
            You pick exactly how much food you want.{' '}
          </span>
          <span>The more you buy, the more you save.</span>
        </Heading>
      }
    />,
  ];
}

export function BudgetBenefits({ next, prev, scrollRef }: Props) {
  useEffect(() => {
    if (next !== null) {
      setSavedNavState(next);
    }
  }, [next]);

  return (
    <ValuePropLayout
      headerText="Hungryroot works with your budget"
      theme={ValuePropComponentTheme.PeanutButter}
      cards={getCards()}
      next={next}
      prev={prev}
      scrollRef={scrollRef}
    />
  );
}
